import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";
import { AssetType } from "@validereinc/domain";

export const AssetTypeOptions = convertMapToOpts(AssetType, ([_, val]) =>
  toTitleCaseString(val)
);
